<template>
  <el-dialog class="manage" top="10vh" :visible="isShow" :show-close="false" :close-on-click-modal="false"
    @close="fCancalPopupShow" :appendToBody='true'>
    <div class=" x-flex x-row-between  x-p-l-5  x-font-14  x-bd-bottom-E">
      <div class='x-flex x-font-14  x-p-15'>{{title}}</div>
      <div class="x-flex x-cur-poi x-w40 x-row-right x-p-r-15 x-h50" @click="fCancalPopupShow">
        <i class="el-icon-close x-font-14 x-p-2 " style=" color:#808080 ;"></i>
      </div>
    </div>
    <div class=" x-flex x-h100p" style="height: 500px;">
      <div class="x-w190 x-h100p x-bd-right x-bd-bottom x-p-l-20 " style="overflow-y: auto;">
        <div style="height:490px ;">
          <!-- <div v-if='from == "kq-cls"' @click="fClickAll"
            class="x-flex x-row-between x-w100p x-p-t-5 x-p-r-5 x-p-b-5 x-cur-poi x-hover-bgc"
            :class="activeTree == '00'?'f600':''">
            <div class=""> 全部卡券 </div>
          </div> -->
          <el-tree ref="tree" default-expand-all highlight-curren :props="treeProps" :data="treeData" node-key="id"
            @node-click='fChgClsTree' :expand-on-click-node="false"></el-tree>
        </div>

        <!-- <el-tree class="c-0" :data="treeData" :props="treeProps" default-expand-all @node-click="fChgClsTree"
            :expand-on-click-node="false"  highlight-current> -->
        <!-- <div class="x-p-10 x-flex x-w100p"> -->

        <!-- </div> -->
      </div>
      <div class="x-flex-1 " style="overflow: hidden;">
        <!-- <div class="x-p-10 x-flex x-w100p x-row-right">
          <div class="x-p-l-10 x-p-t-20">
            <el-checkbox v-model="zcYnCls"></el-checkbox>
            <span>非正常</span>
          </div>
        </div> -->

        <div class=" x-w100p" style="height: 500px;">
          <!-- <div class="x-flex"> -->

          <div class="x-h50 x-flex x-p-r-20"
            v-if="from == 'vip-md'|| from == 'kq-pro' ||from == 'kq-pp' || from=='kq-pro-detail' || from =='kq-gys' || from=='online-pro-detail' || from == 'vip-md-online'">
            <div class=" x-m-r-10 x-flex-1 x-p-l-4" style="min-width: 260px;">
              <el-input :placeholder="placeholder" v-model="searchStr"
                @keydown.enter.native='page.nowPage=1;fChgClsTree("00")'>
                <el-button slot="append" icon="el-icon-search" class="x-search"
                  @click='page.nowPage=1;fChgClsTree("00")'>查询
                </el-button>
              </el-input>
            </div>
            <div class="x-p-r-40">
              <el-checkbox v-model="mhYn"></el-checkbox>
              <span>模糊</span>
            </div>
            <x-button @click.native='fAddTableData'>确认添加</x-button>
          </div>
          <!-- </div> -->
          <!-- 选择商品表 -->
          <div v-if='from=="kq-pro-detail"' style="height: calc(100% - 50px);" class="x-p-l-4 x-p-r-4">
            <vxe-table stripe height='auto' ref="xTable" :data="tableManage" align="center" border="inner"
              :row-config="{isCurrent: true, isHover: true,keyField:'pro_id'}" row-id="pro_id"
              @checkbox-change="fChecked" @checkbox-all="fChecked" :checkbox-config="{ reserve: true }">
              <vxe-column type="checkbox" fixed="left" width="60"></vxe-column>
              <vxe-column title="序" fixed="left" width="60" field="RC"></vxe-column>
              <vxe-column sortable title="编码" field='pro_id' min-width="130px" cell-type='string'> </vxe-column>
              <vxe-column sortable title="名称" field='pro_name' min-width="120px"> </vxe-column>
              <vxe-column sortable title="库存" field='stock' min-width="90px">
                <template slot-scope="scope">
                  <div class="f600" style="color: #FF4545;">{{scope.row.stock}}</div>
                </template>
              </vxe-column>
              <vxe-column v-for="(item,index) in tableDataManageB" :key="index" :field="item.field" :title="item.title"
                :min-width="item.width" sortable>
                <template slot-scope="scope">
                  <div class="x-flex x-row-center">
                    <div class="f600" v-if="item.title=='进货价' || item.title=='零售价'">
                      {{api.numHelper.fMoneyFat(scope.row[item.field])}}
                    </div>
                    <div v-else>{{scope.row[item.field]}}</div>
                  </div>
                </template>
              </vxe-column>
            </vxe-table>
          </div>
          <!-- 线上商城选择商品 -->
          <div v-else-if='from=="online-pro-detail"' style="height: calc(100% - 50px);" class="x-p-l-4 x-p-r-4">
            <vxe-table stripe :data="tableManage" ref="xTable" align="center" height="100%" border="inner"
              @checkbox-change="fChecked" @checkbox-all="fChecked" :checkbox-config="{ reserve: true }"
              :row-config="{isCurrent: true, isHover: true,keyField:'pro_id'}" row-id="pro_id">
              <vxe-column type="checkbox"> </vxe-column>
              <vxe-column v-for="(item,index) in tableDataManageE" :key="item.RC" :field="item.field"
                :title="item.title" :width="item.width" sortable>
                <template slot-scope="scope">
                  <div class="x-flex x-row-center">
                    <div class="f600" v-if="item.title=='售价'">
                      {{api.numHelper.fMoneyFat(scope.row[item.field])}}
                    </div>
                    <div v-else>{{scope.row[item.field]}}</div>
                  </div>
                </template>
              </vxe-column>
            </vxe-table>
          </div>
          <!-- 门店表 -->
          <div v-else-if='from=="vip-md" || from == "vip-md-online"' style="height: calc(100% - 50px);"
            class="x-p-l-4 x-p-r-4">
            <vxe-table stripe height='auto' ref="xTable" :data="tableManage" align="center" border="inner"
              :row-config="{isCurrent: true, isHover: true,keyField:'mall_id'}" row-id="mall_id"
              @checkbox-change="fChecked" @checkbox-all="fChecked" :checkbox-config="{ reserve: true }">
              <vxe-column type="checkbox" fixed="left" width="60"></vxe-column>
              <vxe-column v-for="(item,index) in tableDataManageC" :key="index" :field="item.field" :title="item.title"
                :min-width="item.width" sortable></vxe-column>
            </vxe-table>
          </div>
          <!-- 供应商表 -->
          <div v-else-if='from=="kq-gys"' style="height: calc(100% - 50px);" class="x-p-l-4 x-p-r-4">
            <vxe-table stripe height='auto' ref="xTable" :data="tableManage" align="center" border="inner"
              :row-config="{isCurrent: true, isHover: true,keyField:'gys_id'}" row-id="gys_id"
              @checkbox-change="fChecked" @checkbox-all="fChecked" :checkbox-config="{ reserve: true }">
              <vxe-column type="checkbox" fixed="left" width="60"></vxe-column>
              <vxe-column v-for="(item,index) in tableDataManageD" :key="index" :field="item.field" :title="item.title"
                :min-width="item.width" sortable></vxe-column>
            </vxe-table>
          </div>
          <!-- 其他表 -->
          <div v-else :style="from != 'vip-md'||from != 'vip-md-online'?'height: 100%;':'height: calc(100% - 50px);'"
            class="x-p-l-4 x-p-r-4">
            <vxe-table stripe height='auto' ref="xTable" :data="tableManage" border="inner" align="center"
              :checkbox-config="{checkMethod: checCheckboxkMethod,reserve: true}"
              :row-config="{isCurrent: true, isHover: true,keyField:'cls_id'}" row-id="cls_id"
              @checkbox-change="fChecked" @checkbox-all="fChecked" @cell-dblclick="fDobClick">
              <vxe-column v-if="from == 'vip-md' || from == 'kq-pro'|| from == 'kq-pp' || from == 'vip-md-online' "
                type="checkbox" width="60">
              </vxe-column>
              <vxe-column v-for="(item,index) in tableDataManageA" :key="item.RC" :field="item.field"
                :title="item.title" :min-width="item.width" sortable></vxe-column>
              <vxe-column title="操作" fixed="right" width="70"
                v-if="from != 'vip-md' && from != 'kq-pro'&& from != 'kq-pp' && from != 'fp-mall' && from != 'vip-md-online'">
                <template slot-scope="scope">
                  <div class="x-cur-poi c-cz" @click="fEditCls(scope.row,'EDIT')">编辑</div>
                </template>
              </vxe-column>
            </vxe-table>
          </div>
        </div>
        <!-- 页 -->

      </div>

    </div>
    <div>

      <div class="x-p-r-10 x-p-l-10 x-flex x-row-between x-h50">
        <div class=" x-bd-right x-w180 x-h100p x-flex x-row-left x-p-l-10"
          v-if="from != 'vip-md'&& from != 'kq-pro' &&from != 'kq-pp' && from!='kq-pro-detail' && from!='online-pro-detail' && from!='kq-gys' && from != 'vip-md-online'">
          <el-checkbox v-model="zcYnCls"></el-checkbox>
          <span class="x-p-l-5">非正常</span>
        </div>
        <div class="x-lh-32 x-flex x-flex-1 x-row-between x-p-l-10"
          v-if="from == 'kq-pro-detail'||from == 'online-pro-detail'|| from == 'vip-md' || from == 'vip-md-online'">
          共{{TR}}条 <el-pagination background @current-change="" :page-size="page.pageSize" layout="prev, pager, next"
            :total="TR" @current-change="fCurrentChange"> </el-pagination>
        </div>
      </div>
    </div>

  </el-dialog>
</template>

<script>
  export default {
    props: {
      //来源
      from: {
        type: [String, Boolean],
        default: false,
      },
      // 是否显示
      isShow: {
        type: [String, Boolean],
        default: false,
      },
      // 是否显示
      priceWay: {
        type: [String, Boolean],
        default: false,
      },
      //所属分类列表
      treeData: [Array, Object],
      default: () => {
        return []
      },
      //已经选中的JSON
      json: [Array, Object],
      default: () => {
        return []
      },
      proId: {
        type: [String, Boolean],
        default: '',
      },
    },
    data() {
      return {
        placeholder: "条码,品名,拼音码,自编码",
        mhYn: true,
        searchStr: '',
        activeTree: '',
        activeTreeName: '',
        title: '分类',
        zcYnCls: false,
        treeProps: {
          "label": "cls_name",
          "value": 'cls_id'
        },
        clsData: {},
        tableManage: [],
        //表
        tableDataManageA: [

          {
            field: "cls_id",
            title: "编码",
            width: "100px",
          },
          {
            field: "cls_name",
            title: "名称",
            width: "100px",
          },
          {
            field: "state",
            title: "状态",
            width: "100px",
          },
          {
            field: "chg_user_name",
            title: "修改员工",
            width: "100px",
          }
        ],
        //门店表
        tableDataManageC: [

          {
            field: "mall_id",
            title: "编码",
            width: "100px",
          },
          {
            field: "mall_name",
            title: "名称",
            width: "100px",
          },
          {
            field: "state",
            title: "状态",
            width: "100px",
          },
          {
            field: "chg_user_name",
            title: "修改员工",
            width: "100px",
          }
        ],
        //商品表
        tableDataManageB: [{
          field: "unit",
          title: "单位",
          width: "100px",
        }, {
          field: "sale_price",
          title: "零售价",
          width: "100px",
        }, {
          field: "vip_price",
          title: "会员价",
          width: "100px",
        }, {
          field: "price_way",
          title: "计价方式",
          width: "100px",
        }, {
          field: "pro_type",
          title: "商品类型",
          width: "100px",
        }, {
          field: "cls_name",
          title: "所属分类",
          width: "100px",
        }, ],
        //供应商
        tableDataManageD: [{
          field: "gys_id",
          title: "编码",
          width: "130px",
        }, {
          field: "gys_name",
          title: "名称",
          width: "120px",
        }, {
          field: "wl_money",
          title: "应付款",
          width: "90px",
        }, {
          field: "mall_name",
          title: "所属门店",
          width: "100px",
        }, {
          field: "price_way",
          title: "采购价格",
          width: "100px",
        }, {
          field: "lnk_person",
          title: "联系人",
          width: "90px",
        }, {
          field: "phone",
          title: "手机",
          width: "120px",
        }, {
          field: "chg_user_name",
          title: "修改员工",
          width: "100px",
        }, {
          field: "chg_time",
          title: "修改时间",
          width: "160px",
        }],
        //线上商城选择商品
        tableDataManageE: [{
            field: "pro_id",
            title: "条码",
            width: "140px",
          },
          {
            field: "pro_name",
            title: "名称",
            width: "140px",
          },
          {
            field: "unit",
            title: "单位",
            width: "90px",
          },
          {
            field: "stock",
            title: "库存",
            width: "90px",
          },
          {
            field: "sale_price",
            title: "售价",
            width: "90px",
          }

        ],
        //页
        TP: 0,
        TR: 0,
        page: {
          pageSize: 50,
          nowPage: 1
        },
        //临时数组
        checkList: [],
        // selectedPapers: new Set() // 选中数据
      }
    },
    created() {
      if (this.from == 'commodity') {
        this.title = '商品分类'
      }
      if (this.from == 'supplier') {
        this.title = '供应商分类'
      }
      if (this.from == 'employees') {
        this.title = '员工分类'
      }
      if (this.from == 'store') {
        this.title = '门店分类'
      }
      if (this.from == 'pp') {
        this.title = '品牌分类'
      }
      if (this.from == 'kh') {
        this.title = '客户分类'
      }
      if (this.from == 'vip-md' || this.from == 'vip-md-online') {
        this.title = '选择门店'
      }
      if (this.from == 'kq-pro-detail' || this.from == 'online-pro-detail') {
        this.title = '选择商品'
      }
      if (this.from == 'fp-mall') {
        this.title = '选择员工组'
      }
      if (this.from == 'table') {
        this.title = '餐桌分类'
      }
      if (this.from == 'jmCls') {
        this.title = '加盟分类'
      }
      if (this.from == 'jmPro') {
        this.title = '加盟商品分类'
      }



    },
    watch: {
      zcYnCls(newVal) {
        if (this.from == 'kq-cls') {
          this.fClickAll()
          return
        }
        this.fChgClsTree({
          cls_id: '00'
        })
      },
      isShow(newVal) {
        if (newVal) {

          if (this.from == 'kq-cls') {
            setTimeout(() => {
              this.fClickAll()
            }, 100)
            return
          }
          this.fChgClsTree({
            cls_id: '00'
          })
        }
      },
      // treeData() {
      //   this.fChgClsTree({
      //     cls_id: '00'
      //   })
      // }
    },
    methods: {
      //选中内分类树
      async fChgClsTree(data) {
        this.clsData = data
        let res = null
        //获取商品分类
        if (this.from == 'commodity' || this.from == 'kq-pro') {
          res = await this.api.smCommon.fGetClsInfo('PRO', 'SUB_CLS', data.cls_id, this.zcYnCls)
        }
        //获取商品详情
        if (this.from == 'kq-pro-detail') {

          res = await this.api.smCommon.fGetProInfo({
            oper: 'PRO_LIST',
            clsId: data.cls_id,
            searchStr: this.searchStr,
            pageSize: this.page.pageSize,
            nowPage: this.page.nowPage,
            zcYn: this.zcYnCls,
            mhYn: this.mhYn,
            orderBy: '',
            priceWay: this.priceWay || '',
          })
        }
        if (this.from == 'online-pro-detail') {

          res = await this.fGetWgoProInfo({
            oper: 'PRO_LIST',
            clsId: data.cls_id,
            searchStr: this.searchStr,
            pageSize: this.page.pageSize,
            nowPage: this.page.nowPage,
            zcYn: this.zcYnCls,

            mhYn: this.mhYn,
            orderBy: '',
            priceWay: this.priceWay || '',
          })
        }

        if (this.from == 'table') {
          res = await this.api.smCommon.fGetClsInfo('TABLE', 'SUB_CLS', data.cls_id, this.zcYnCls)
        }
        if (this.from == 'supplier') {
          this.placeholder = "编码,拼音码"
          res = await this.api.smCommon.fGetClsInfo('GYS', 'SUB_CLS', data.cls_id, this.zcYnCls)
        }
        if (this.from == 'employees' || this.from == 'fp-mall') {
          res = await this.api.smCommon.fGetClsInfo('USER', 'SUB_CLS', data.cls_id, this.zcYnCls)
        }
        if (this.from == 'store') {
          this.placeholder = "编码,拼音码"
          res = await this.api.smCommon.fGetClsInfo('MALL', 'SUB_CLS', data.cls_id, this.zcYnCls)
        }
        if (this.from == 'vip') {
          res = await this.api.smCommon.fGetClsInfo('VIP', 'SUB_CLS', data.cls_id, this.zcYnCls)
        }
        if (this.from == 'kh') {
          res = await this.api.smCommon.fGetClsInfo('KH', 'SUB_CLS', data.cls_id, this.zcYnCls)
        }
        if (this.from == 'kq') {
          this.placeholder = "编码,拼音码"
          res = await this.fGetKqInfo('KQ_LIST', data.cls_id, this.zcYnCls)
        }
        if (this.from == 'color') {
          res = await this.api.smCommon.fGetClsInfo('COLOR', 'SUB_CLS', data.cls_id, this.zcYnCls)
        }
        if (this.from == 'size') {
          res = await this.api.smCommon.fGetClsInfo('SIZE', 'SUB_CLS', data.cls_id, this.zcYnCls)
        }
        if (this.from == 'kq-cls') {
          if( data.cls_id == '00'){
            res = await this.api.smCommon.fGetClsInfo('KQ', 'CLS_LIST', data.cls_id, this.zcYnCls)
          }else{
            res = await this.api.smCommon.fGetClsInfo('KQ', 'CLS_ID', data.cls_id, this.zcYnCls)
          }
        }
        if (this.from == 'kq-gys') {
          res = await this.api.smCommon.fGetGysInfo({
            oper: 'GYS_LIST',
            clsId: data.cls_id || '00',
            searchStr: this.searchStr,
            pageSize: this.page.pageSize,
            nowPage: this.page.nowPage,
            zcYn: this.zcYnCls,
            mhYn: this.mhYn,
            orderBy: '',
          })
        }
        if (this.from == 'vip-md' || this.from == 'vip-md-online') {
          this.placeholder = "编码,拼音码"
          res = await this.api.smCommon.fGetMallInfo({
            oper: 'MALL_LIST',
            clsId: data.cls_id || '00',
            searchStr: this.searchStr,
            pageSize: this.page.pageSize,
            nowPage: this.page.nowPage,
            zcYn: this.zcYnCls,
            mhYn: this.mhYn,
            onlineShow: this.from == 'vip-md' ? '全部' : "否"
          })
        }
        if (this.from == 'onlinePro') {
          res = await this.fGetWgoProClsData('SUB_CLS', data.cls_id)
        }

        if (this.from == 'pp' || this.from == 'kq-pp') {
          this.placeholder = "编码,拼音码"
          res = await this.api.smCommon.fGetPpInfo({
            oper: 'PP_LIST',
            searchStr: data.cls_id,
            pageSize: this.page.pageSize,
            nowPage: this.page.nowPage,
            zcYn: this.zcYnCls,
            mhYn: this.mhYn,
          })
        }
        if (this.from == 'jmCls') {
          res = await this.api.smCommon.fGetJmMallClsInfo({
            oper: 'LIST',
            clsId: data.cls_id,
            zcYn: this.zcYnCls,
          })
        }
        if (this.from == 'jmPro') {
          res = await this.api.smCommon.fGetJmProClsInfo({
            oper: 'LIST',
            clsId: data.cls_id,
            zcYn: this.zcYnCls,
          })
        }

        if (res.result != 'sucess') {
          return this.$message(res.msg)
        }
        this.tableManage = res.data
        if (this.from == 'online-pro-detail') {
          //首先排除自己
          this.tableManage.forEach((item, index) => {
            if (item.pro_id == this.proId) {
              this.tableManage.splice(index, 1)
            }
          })
          //再排除已有的推荐商品
          // this.tableManage.forEach((item, index) => {
          //   if (item.pro_id == this.proId) {
          //     this.tableManage.splice(index, 1)
          //   }
          //   this.json.forEach((item1, index1) => {
          //     if (item.pro_id == item1.pro_id) {
          //       this.tableManage.splice(index, 1)
          //     }
          //   })

          // })
        }
        this.fShowCheak(this.checkList)
        if (res.data.length > 0) {
          this.TP = Number(res.data[0].TP)
          this.TR = Number(res.data[0].TR)
        } else {
          this.TP = 0
          this.TR = 0
        }
      },
      //操作商品分类
      async fEditCls(data, oper) {
        if (data.cls_id.length == 2) {
          return this.$message('最大分类暂不允许修改')
        }
        if (this.from == 'kq-cls') {
          let res = await this.api.smCommon.fGetClsInfo('KQ', 'CLS_ID', data.cls_id, this.zcYnCls)
          if (res.result != 'sucess') {
            return this.$message(res.msg)
          }
          let kqClsInfo = res
          this.$emit('fChgCls', kqClsInfo)
          return
        }
        this.$emit('fChgCls', data, this.zcYnCls)
      },
      //禁用
      checCheckboxkMethod({
        row
      }) {
        return row.cls_id.length > 2
      },
      //添加VIP弹窗内门店数据
      fAddTableData() {
        // this.fChecked()
        // let res = this.$refs.xTable.getCheckboxRecords(true)
        if (this.checkList.length < 1) {
          return this.$message('请勾选数据')
        }
        console.log(this.checkList)
        this.$emit("fAddTableData", this.checkList);
      },
      fDobClick(e) {
        if (e.row.cls_id.length > 2) {
          this.$emit("fDobClick", e.row);
        }
      },
      //卡券分类
      //点击全部
      async fClickAll() {
        this.$refs.tree.setCurrentKey(null);
        this.activeTree = '00'
        this.activeTreeName = '全部卡券'
        let res = await this.api.smCommon.fGetClsInfo('KQ', 'CLS_LIST', '', this.zcYnCls)
        if (res.result != 'sucess') {
          return this.$message(res.msg)
        }
        this.tableManage = res.data
        if (res.data.length > 0) {
          this.TP = res.data[0].TP
          this.RC = res.data.length
        }
      },
      //分页
      async fCurrentChange(e) {
        // this.fChecked()
        this.page.nowPage = e;
        this.fChgClsTree(this.clsData)
      },
      //关闭弹窗
      fCancalPopupShow() {
        this.checkList = []
        this.$emit("cencal");
      },

      //复选框回显
      fShowCheak(json) {
        this.checkList = json || this.json
        // 复选框回显
        let rowId = ''
        let check = false
        switch (this.from) {
          case 'vip-md':
          case 'vip-md-online':
            rowId = 'mall_id'
            check = true
            break
          case 'kq-pro-detail':
          case 'online-pro-detail':
            rowId = 'pro_id'
            check = true
            break
          case 'kq-pp':
          case 'kq-pro':
            rowId = 'cls_id'
            check = true
            break
        }

        if (check) {
          this.$refs.xTable.setAllCheckboxRow(false)
          this.checkList.forEach(item1 => {
            this.tableManage.forEach(async (item, index) => {
              if (item[rowId] == item1[rowId]) {
                let row = await this.$refs.xTable.getRowById(item[rowId])
                await this.$refs.xTable.setCheckboxRow(this.$refs.xTable.getRowById(item[rowId]), true)
              }
            })
          })
        }
      },
      // 选中
      fChecked(obj) {
        console.log(obj)
        let rowId = ''
        let check = false
        switch (this.from) {
          case 'vip-md':
          case 'vip-md-online':
            rowId = 'mall_id'
            check = true
            break
          case 'kq-pro-detail':
          case 'online-pro-detail':
            rowId = 'pro_id'
            check = true
            break
          case 'kq-pp':
          case 'kq-pro':
            rowId = 'cls_id'
            check = true
            break
        }
        //如果obj没有data为全选
        if (this.api.smCom.fSmIsEmpty(obj.data)) {
          if (obj.checked) {
            this.checkList = this.checkList.concat(this.tableManage)
            this.checkList = this.api.smCom.uniqueArray(this.checkList, rowId)
            console.log(this.checkList)
          } else {
            let arr = []
            this.checkList.forEach((item, index) => {
              let idx = this.tableManage.findIndex(tableManageItem => {
                return item[rowId] == tableManageItem[rowId]
              })
              if (idx == -1) {
                arr.push(item)
                return
              }
            })
            this.checkList = this.api.smCom.uniqueArray(arr, rowId)
          }
          //去空
          //否则为单选
        } else {
          if (obj.checked) {
            this.checkList = this.checkList.concat(obj.row)
            this.checkList = this.api.smCom.uniqueArray(this.checkList, rowId)
          } else {
            this.checkList.forEach((item, index) => {
              if (item[rowId] == obj.row[rowId]) {
                this.checkList.splice(index, 1)
              }
            })
          }
        }
        // let res = this.$refs.xTable.getCheckboxRecords(true)
        // if (!this.api.smCom.fSmIsEmpty(res)) {
        //   this.checkList = this.checkList.concat(res)
        //   this.checkList = this.api.smCom.uniqueArray(this.checkList, rowId)
        // }
      },

      // 请求===========================
      // 获取卡券列表
      async fGetKqInfo(oper, clsId) {
        let js = {};
        js['OPER'] = oper;
        // js['MALL_ID'] = this.gSh.mallId;
        js['CLS_ID'] = clsId || '00';
        js['SEARCH_STR'] = this.searchStr;
        js['PAGE_SIZE'] = this.page.pageSize;
        js['NOW_PAGE'] = this.page.nowPage;
        js['ZC_YN'] = this.zcYnCls ? "N" : "Y";
        js['MH_YN'] = this.mhYn ? "Y" : "N";

        let res = await this.api.smSellApi.fPostToSmSellQueryApi('GET_KQ_INFO', js)

        return res;
      },
      //
      async fGetWgoProClsData(oper, clsId, ) {
        let js = {};
        js['OPER'] = oper;
        js['MALL_ID'] = this.$store.state.smSellAdmin.shMallId;
        js['CLS_ID'] = clsId || '00';
        js['ZC_YN'] = this.zcYnCls ? "N" : "Y"
        let res = await this.api.smSellApi.fPostToSmSellWgoApi('GET_WGO_PRO_CLS_DATA', js)
        return res;
      },
      async fGetWgoProInfo(obj) {
        let js = {};
        js['OPER'] = obj.oper;
        js['MALL_ID'] = obj.mallId || this.$store.state.smSellAdmin.shMallId;
        js['CLS_ID'] = obj.clsId || '00';
        js['GYS_ID'] = obj.gys_id || '';
        js['PP_ID'] = obj.pp_id || '';
        js['SEARCH_STR'] = obj.searchStr;
        js['PAGE_SIZE'] = obj.pageSize || '50';
        js['NOW_PAGE'] = obj.nowPage || '1';
        js['ZC_YN'] = obj.zcYn ? "N" : "Y";
        js['MH_YN'] = obj.mhYn ? "Y" : "N";
        js['ORDER_BY'] = obj.orderBy
        js['PRO_TYPE'] = obj.proType || ''
        js['PRICE_WAY'] = obj.priceWay
        js['ONLINE_STATE'] = '已上架'
        js['PRO_GLTJ_MAIN_PRO_ID'] = this.proId
        let res = await this.api.smSellApi.fPostToSmSellWgoApi(' GET_WGO_PRO_INFO', js)
        return res;
      },
    }
  }
</script>

<style scoped="scoped" lang="less">
  /deep/.el-dialog {
    width: 800px;
    height: 600px;
  }

  /deep/.vxe-table--render-default .vxe-cell {
    white-space: unset;
  }

  //添加嵌套多出来的头部
  /deep/.el-dialog__header {
    display: none;
  }

  //添加嵌套多出来的内边距
  /deep/.el-dialog__body {
    padding: 0px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/cls_manage.vue